import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios, { AxiosError } from "axios";

export async function getOrder(id: string): Promise<any> {
  try {
    const response = await axiosInstance.get(`${config.apiUrl}/orders/${id}`);
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new AxiosError(error.response?.data?.message || "Error fetching order");
    } else {
      throw new Error("An unknown error occurred");
    }
  }
}
